import { PERMISSIONS } from '@conversed/shared/src/central/constants/permissions';
import { z } from 'zod';

import { createRESTContract } from '../../index';
import {
  InboxAgentSchema,
  InboxSchema,
  InboxSchemaCreate,
} from './inbox.schema';

const { INBOX } = PERMISSIONS;

export const inboxContract = createRESTContract({
  createInbox: {
    method: 'POST',
    path: '/inboxes',
    permissions: [INBOX.INBOX_CREATE],
    response: InboxSchema,
    body: InboxSchemaCreate,
  },
  getAllInboxesOfCompany: {
    method: 'GET',
    path: '/inboxes',
    permissions: [INBOX.INBOX_LIST],
    response: z.array(InboxSchema),
  },
  getAllInboxesOfAgentInCompany: {
    method: 'GET',
    path: '/inboxes/agent',
    permissions: [INBOX.INBOX_LIST],
    response: z.array(InboxAgentSchema),
  },
  updateInbox: {
    method: 'PUT',
    path: '/inboxes/:id',
    permissions: [INBOX.INBOX_EDIT],
    response: z.void(),
    body: InboxSchemaCreate,
  },
  deleteInbox: {
    method: 'DELETE',
    path: '/inboxes/:id',
    permissions: [INBOX.INBOX_REMOVE],
    response: z.void(),
    body: z.undefined(),
  },
});
